<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div
            class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
          >
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
                <tr class="bg-light-paper">
                  <th class="header">
                    Session
                  </th>
                  <th class="header">
                    Aspire
                  </th>
                  <th class="header">
                    VCarve
                  </th>
                  <th class="header">
                    Cut2D
                  </th>
                  <th class="header">
                    Reminders
                  </th>
                </tr>
              </thead>
              <tbody class="bg-vlight-paper divide-y divide-green">
                <tr v-for="(session, index) in sessions" :key="index">
                  <td class="rowStyle">
                    {{ session.title }}
                  </td>
                  <td class="rowStyle">
                    <svg
                      v-if="aspire(session)"
                      class="h-5 w-5 text-darkpurple"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </td>
                  <td class="rowStyle">
                    <svg
                      v-if="vcarve(session)"
                      class="h-5 w-5 text-darkpurple"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </td>
                  <td class="rowStyle">
                    <svg
                      v-if="cut2d(session)"
                      class="h-5 w-5 text-darkpurple"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </td>
                  <td class="rowStyle">
                    {{ reminderCount(session) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import {
  commentsCollection,
  projectCommentsCollection,
  remindersCollection
} from "../utils/firebase";
import { getAllReminders } from "../utils/functions";
export default {
  name: "AdminStats",
  data() {
    return {
      sessions: [],
      sessionsLoaded: false,
      reminders: {},
      sessionComments: {}
    };
  },
  mounted() {
    this.fetchSessions();
    this.fetchReminders();
    this.fetchSessionComments();
  },
  methods: {
    aspire(session) {
      return (
        session.productCompatibility.filter(s => s.productName === "Aspire")
          .length > 0
      );
    },
    vcarve(session) {
      return (
        session.productCompatibility.filter(s => s.productName === "VCarve Pro")
          .length > 0
      );
    },
    cut2d(session) {
      return (
        session.productCompatibility.filter(s => s.productName === "Cut2D Pro")
          .length > 0
      );
    },
    reminderCount(session) {
      if (
        !Object.prototype.hasOwnProperty.call(
          this.reminders,
          session.slug.current
        )
      ) {
        return 0;
      }
      return this.reminders[session.slug.current].length;
    },
    commentCount(session) {
      if (
        !Object.prototype.hasOwnProperty.call(this.sessionComments, session._id)
      ) {
        return 0;
      }
      return this.sessionComments[session._id].length;
    },
    chatCount(session) {
      return 0;
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session' && !(_id in path('drafts.**'))] | order(startTime asc) {productCompatibility[]->{...}, ...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          this.sessions = res;
          this.sessionsLoaded = true;
        })
        .catch(err => console.error(err));
    },
    fetchReminders() {
      const reminders = {};
      getAllReminders().then(res => {
        this.reminders = res.data;
      });
    },
    fetchSessionComments() {
      const sessionComments = {};
      projectCommentsCollection.get().then(snapShot => {
        console.log(snapShot);
        snapShot.forEach(doc => {
          let session = doc.data().session;
          if (!sessionComments[session]) {
            sessionComments[session] = [];
          }
          sessionComments[session].push(doc.data());
        });
        this.sessionComments = sessionComments;
      });
    }
  }
};
</script>

<style scoped>
.header {
  @apply px-6 py-3  text-left text-xs leading-4 font-semibold text-darkpurple uppercase tracking-wider;
}
.rowStyle {
  @apply px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900;
}
</style>
